/* eslint-disable no-shadow */
/* eslint-disable object-shorthand */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-alert */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  TextField,
  Typography,
} from "@mui/material";
import {
  Close as CloseIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import React, { useState } from "react";

import EditableTable from "components/smea/Table/EditableTable";
import dayjs from "dayjs";
import { useStateContext } from "contexts/ContextProvider";
import useAxiosPrivate from "contexts/interceptors/axios";

export default function SubmissionsTable({
  data,
  setSelectedData,
  loadingState,
  updateTableFunction,
}) {
  const { auth } = useStateContext();
  const axiosPrivate = useAxiosPrivate();
  const [selectedSubmission, setSelectedSubmission] = useState();
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [remarkDialogOpen, setRemarkDialogOpen] = useState(false);
  const [remark, setRemark] = useState("");
  const [viewRemarkDialogOpen, setViewRemarkDialogOpen] = useState(false);

  setSelectedData(selectedSubmission);

  function getPreviewUrl(FileId) {
    return `https://drive.google.com/file/d/${FileId}/preview`;
  }

  const handlePreview = (fileId, title) => {
    if (!fileId) {
      console.error("No file ID provided for preview.");
      return;
    }

    const previewUrl = getPreviewUrl(fileId);
    setPreviewUrl(previewUrl); // Set the preview URL to state
    setPreviewTitle(title); // Set the material title to state
    setPreviewModalOpen(true); // Open the preview modal
  };

  const handleClosePreviewModal = () => {
    setPreviewModalOpen(false); // Close the preview modal
    setPreviewUrl(""); // Clear the preview URL
    setPreviewTitle(""); // Clear material title
  };

  const handleAccept = async () => {
    setLoading(true);
    if (!selectedSubmission || !selectedSubmission[0]?.id) {
      alert("No submission selected or invalid submission.");
      setLoading(false);
      return;
    }

    await axiosPrivate
      .put(`/I-Abide/acceptRejectDocument/${selectedSubmission[0].id}`, {
        newStatus: "Accepted",
        remarks: "Submission accepted.",
      })
      .then(() => {
        updateTableFunction();
        handleClosePreviewModal();
      })
      .catch((error) => {
        console.error("Failed to accept submission:", error);
        alert("Failed to accept submission: ", error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleReject = () => {
    setRemarkDialogOpen(true);
  };

  const submitRejection = async () => {
    setLoading(true);
    setRemarkDialogOpen(false);

    if (!selectedSubmission || !selectedSubmission[0]?.id) {
      alert("No submission selected or invalid submission.");
      setLoading(false);
      return;
    }

    await axiosPrivate
      .put(`/I-Abide/acceptRejectDocument/${selectedSubmission[0].id}`, {
        newStatus: "Rejected",
        remarks: remark,
      })
      .then(() => {
        updateTableFunction();
        handleClosePreviewModal();
      })
      .catch((error) => {
        console.error("Failed to reject submission:", error);
        alert("Failed to reject submission: ", error.message);
      })
      .finally(() => {
        setLoading(false);
        setRemark("");
      });
  };

  const handleViewRemark = () => {
    setViewRemarkDialogOpen(true);
  };

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: (params) => {
        const { FileId, FileName } = params.row;

        return (
          <Tooltip title={FileName ? "View File" : "No File Available"}>
            <span>
              <IconButton
                disabled={!FileName}
                sx={{ color: FileName ? "#1976d2" : "grey" }}
                onClick={() => handlePreview(FileId, FileName)} // Pass 'submissionId' instead of 'FileId'
              >
                <VisibilityIcon />
              </IconButton>
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      renderCell: (params) => {
        const status = params.value;
        const color =
          status === "Accepted"
            ? "green"
            : status === "Rejected"
            ? "red"
            : "inherit";

        return <Box sx={{ color: color, fontWeight: "bold" }}>{status}</Box>;
      },
    },
    { field: "submitted_by", headerName: "Submitted By", width: 200 },
    { field: "postTitle", headerName: "Post Title", width: 200 },
    { field: "postedBy", headerName: "Posted By", width: 200 },
    { field: "officeName", headerName: "Office Name", width: 200 },
    { field: "remarks", headerName: "Remarks", width: 200 },
    { field: "submission_status", headerName: "Submission Status", width: 200 },
    { field: "FileName", headerName: "Document Name", width: 450 },
    { field: "FileSize", headerName: "File Size", width: 150 },
    { field: "FileId", headerName: "File Id", width: 350 },
    {
      field: "date_submitted",
      headerName: "Date Submitted",
      width: 200,
      valueGetter: (params) => dayjs(params.value).format("YYYY-MM-DD hh:mm A"),
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <EditableTable
        data={data}
        columns={columns}
        checkbox
        loading={loadingState || loading}
        setSelectedData={setSelectedSubmission}
        height="75vh"
        showSearch
      />

      <Dialog
        open={previewModalOpen}
        onClose={handleClosePreviewModal}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            background: "#02690c",
            color: "white",
            padding: "16px",
          }}
        >
          <span style={{ flexGrow: 1, textAlign: "center" }}>
            {previewTitle || "File Preview"}
          </span>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClosePreviewModal}
            sx={{ color: "white", "&:hover": { backgroundColor: "#005300" } }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <iframe
            src={previewUrl}
            width="100%"
            height="800px"
            title="File Preview"
            frameBorder="0"
          ></iframe>
        </DialogContent>

        <DialogActions>
          <Button color="primary" onClick={handleViewRemark}>
            View Remarks
          </Button>
          {(auth?.role === "admin" || auth?.role === "cid - eps") && (
            <>
              <Button onClick={handleReject} color="error">
                Reject
              </Button>
              <Button onClick={handleAccept} color="primary">
                Accept
              </Button>
            </>
          )}
          <Button onClick={handleClosePreviewModal}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={remarkDialogOpen}
        onClose={() => setRemarkDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Reason</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Rejection Remark"
            fullWidth
            variant="outlined"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRemarkDialogOpen(false)}>Cancel</Button>
          <Button onClick={submitRejection} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={viewRemarkDialogOpen}
        onClose={() => setViewRemarkDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Remark</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            {data[0]?.remarks || "No remark available."}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewRemarkDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
